var map = {
	"./casino-1go.webp": 7651,
	"./casino-beef.webp": 84,
	"./casino-drip.webp": 4993,
	"./casino-flagman.webp": 7028,
	"./casino-fresh.webp": 9630,
	"./casino-fugu.webp": 5375,
	"./casino-gizbo.webp": 6991,
	"./casino-iris.webp": 1881,
	"./casino-irwin.webp": 9293,
	"./casino-izzi.webp": 6628,
	"./casino-jet.webp": 1769,
	"./casino-legzo.webp": 905,
	"./casino-lex.webp": 8931,
	"./casino-martin.webp": 117,
	"./casino-monro.webp": 5471,
	"./casino-rox.webp": 3459,
	"./casino-sol.webp": 3108,
	"./casino-starda.webp": 8993,
	"./casino-volna.webp": 8158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3735;